import React from 'react'
import { FormPro } from '@roo/roo'
import Input from '@roo/roo/Input'
import QuestionTooltip from '@/components/QuestionTooltip'

import { useTranslation } from '@sailor/i18n-web'

/** 生效时间startTime  结束时间endTime */
const TitleDesFormItems = () => {
  const { t } = useTranslation()
  return (
    <>
      <FormPro.Item label={t('e_pc_rule_name', '规则名称')} name="rulePackageName" required
        extra={
          <div>
            <span>{t('e_pc_rule_name_note', '企业员工将会在Keeta客户端看到次规则名称，请注意填写')}</span>
            {/* <QuestionTooltip>
              <img
                style={{ height: '500px' }}
                src={t('e_pc_rule_name_pic', 'https://img-ap-hongkong.mykeeta.net/sailorcweb/dd651285eaa3de37bf7c1844eee8bbbe358924.png')} alt=""
              />
            </QuestionTooltip> */}
          </div>
        }
        rules={[{ required: true, max: 50, message: t('e_pc_please_enter_the_rule_package_name_maximum_50_characters', '请输入规则名称（最多50字符）') }]}
      >
        <Input type="text" placeholder={t('e_pc_please_enter_the_rule_package_name_maximum_50_characters', '请输入规则名称（最多50字符）')} />
      </FormPro.Item>

      <FormPro.Item label={t('e_pc_rule_description', '规则描述')} name="rulePackageDescription" required
        extra={
          <div>
            <span>{t('e_pc_employees_will_see_the_explanation_of_this_rule_please_pay_attention_to_filling_it_out', '员工将看到本规则说明,请注意填写')}</span>
            {/* <QuestionTooltip>
              <img
                style={{ height: '500px' }}
                src={t('e_pc_rule_description_pic', 'https://img-ap-hongkong.mykeeta.net/sailorcweb/1c96719fb0f6d01ecbfdbc57c500f7bb360267.png')} alt="" />
            </QuestionTooltip> */}
          </div>
        }
        rules={[{ required: true, max: 200, message: t('e_pc_please_enter_a_rule_package_description_up_to_200_characters', '请输入规则描述（最多200字符）') }]}
      >
        <Input type="text" placeholder={t('e_pc_please_enter_a_rule_package_description_up_to_200_characters', '请输入规则描述（最多200字符）')} />
      </FormPro.Item>
    </>
  )
}
export default TitleDesFormItems